import React, { useRef, useContext } from 'react';
import { BannerContext } from '../../contexts/BannerDimensionsContext';
import { HtmltoObject } from '../../helpers/formaterTxt.js';
import FormatosReanimate from '../../res/formatosReanimate.js'
import { LoadReanimateFile } from '../../helpers/fileManager.js';
import UpdateFormats from '../../helpers/updateFormats';
import { ObjectToHtml } from '../../helpers/formaterBanner';
import { GetBannerSize } from '../../helpers/fileManager.js';
import { AuthValidatorContext } from '../../contexts/auth';

function LoadFile(props) {
  const refInput = useRef(null);
  const { setMaster, setMasterFormat, setReplicate, setListaReplicas, setLoading, setReplicaActive, setBackgroundStage, assets, setAssets } = useContext(BannerContext);
  const { setAuth, client } = useContext(AuthValidatorContext);

  function openFile() {
      setAuth(true);
    setLoading({show: true, progress: false});
    setListaReplicas([]);
    const file = refInput.current.files[0];
    const fr = new FileReader();
    try {
    fr.onload = async ({ currentTarget }) => {
      const name = file.name;
      const type = name.split(".");
      const ext = type[type.length - 1].toLowerCase()
      if (ext === "rean") {
        var res = await LoadReanimateFile(currentTarget.result);
        const format = [];
        if (res.master) {
          res.master.name = name;
          res.master.fileType = "Reanimate";
          getFormat(res.master.width, res.master.height);
          res.html = ObjectToHtml(res, true);
          res.size = GetBannerSize(res.html);
          setBackgroundStage(res.master.backgroundColor === "#ffffff")
          setMaster(res.master);
        } if (res.listaReplicas[0]) {
          res.listaReplicas.forEach(replica => {
            if (!replica.pack) replica.pack = true;
            format.push([replica.width, replica.height]);            
          });
          setReplicate(UpdateFormats(format, client));
          setListaReplicas(res.listaReplicas);
          setReplicaActive(`${res.listaReplicas[0].width}x${res.listaReplicas[0].height}`);
        }
        console.log('res.master')
        console.log(res.master)
        setAssets(res.assets);
        //SaveFileCookie(res.master, res.listaReplicas);
      } else if (ext === "html") {
        const newMaster = HtmltoObject(currentTarget.result);
        getFormat(newMaster.width, newMaster.height);
        newMaster.name = name;
        newMaster.fileType = "HTML";
        //SaveFileCookie(newMaster, null);
        setListaReplicas([]);
        setReplicate(FormatosReanimate(client));
        newMaster.html = ObjectToHtml(newMaster, true);
        newMaster.size = GetBannerSize(newMaster.html);
        newMaster.elements.forEach(element => {
          element.properties.originalBackground = element.properties.background;
        });
        setMaster(newMaster);
      } else {
      }
      setLoading({show: false, progress: false});;
    }
    const textFile = fr.readAsText(file);
    refInput.current.value = "";
    return textFile;
    } catch(error) {}    
  }

  function getFormat(width, height) {
    console.log('client')
    console.log(client)
    const formats = FormatosReanimate(client);
    console.log('formats', formats)
    var type = null;
    formats.formats.forEach(item => {
      if (item.width === width && item.height === height) {
        type = item.type;
        setMasterFormat(type);
        return;
      }
    });
    if (type) return;
    else if (width === height) setMasterFormat("Quadrado");
    else if (height / width > 1.5) setMasterFormat("Vertical");
    else setMasterFormat("Horizontal");
  }

  return(
    <div onClick={() => refInput.current.click()}>
      {props.children ? props.children : ""}
      <input 
        type='file' 
        id='file-upload-html'
        ref={refInput}
        style={{display: 'none'}}
        onChange={() => openFile()}
        />
    </div>
  )
}

export default LoadFile;